<template>
  <div class="NavPanel" :class="{ 'border-bottom': !isShowBorder }" v-if="level_one?.meta?.showNavPanel">
    <div class="bg" v-if="isShowBorder"></div>
    <div class="content">
      <h1>{{ level_one.meta?.title }}</h1>
      <ul :style="{ width: 144 * level_two.length + 'px', display: 'flex' }">
        <li
          @click="toPath(item.path)"
          v-for="item in level_two"
          :class="{ active: isActive(item.path) }"
          :key="item.path"
        >
          {{ item?.meta?.title }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script setup>
/**
 * 通过读取路由`meta.showNavPanel`的值来控制显示
 *
 * 展示二级导航面板
 */
import { useRouter, useRoute } from '@/hooks/useRouter'
import { computed } from 'vue'

const router = useRouter()
const route = useRoute()

const level_one = computed(() => {
  const path = '/' + route.value.path.split('/')[1]
  const find = router.options.routes.find((r) => r.path === path)
  return find
})

const level_two = computed(() => {
  if (level_one.value.children) {
    return level_one.value.children.filter((i) => !i.meta?.hide)
  }
  return []
})

const isShowBorder = computed(() => {
  return route.value.meta?.showNavPanelBorder === false
})

function isActive(path) {
  if (route.value.query.form) {
    return route.value.query.form === `${level_one.value.path}/` + path
  }
  return route.value.path === `${level_one.value.path}/` + path
}
function toPath(path) {
  const newPath = `${level_one.value.path}/` + path

  if (route.value.path !== newPath) {
    router.push(newPath)
  }
}
</script>
<style lang="less" scoped>
.NavPanel {
  position: relative;
  background-image: url('@/assets/images/NavPanel_bg.jpg');
  .bg {
    background-image: url('@/assets/images/NavPanel_bg.jpg');
    position: absolute;
    left: 0;
    right: 0;
    height: 310px;
    z-index: 0;
  }
  .content {
    position: relative;
    z-index: 2;
  }
  h1 {
    font-size: 30px;
    color: @primary;
    line-height: 36px;
    padding: 50px 0 21px 0;
    text-align: center;
  }
  ul {
    margin: 0 auto;
    li {
      border-top: 1px solid #dbced7;
      padding: 21px 23px;
      width: 144px;
      text-align: center;
      display: inline-block;
      color: #5a5a5a;
      transition: all 0.2s;

      &.active,
      &:hover {
        border-top: 1px solid @primary;
        color: @primary;
        cursor: pointer;
      }
    }
  }
}
</style>
